module.exports = __webpack_public_path__ + "static/media/VE.dddb545b.svg";